export const POLL_CLASS = "ck-poll";

export type PollProps = {
	question: string;
	agreeWording: string;
	disagreeWording: string;
	colorScheme: { darkColor: string; lightColor: string; bannerTextColor: string };
	duration: { days: number; hours: number; minutes: number };
	/** Set by server when post is published. */
	endDate?: string;
	/** Set by CKEditor when user edits duration on a published poll. Signals server to update endDate. */
	durationEdited?: boolean;
};

export const MAX_POLL_DURATION_DAYS = 365;
